import { Outlet } from 'react-router-dom'

import { Box, Spinner } from '@factorialco/deprecated-design-system'
import { PerformanceCyclesCanManagePolicyDocument } from 'generated/resources/graphql'

import AuthorizeUser from 'modules/core/components/AuthorizeUser'
import { useQuery } from 'modules/core/hooks/useQuery'

import CollectionsBootstrap from 'modules/performance_cycles/lib/CollectionsBootstrap'

const RootPage = () => {
  const { data: policyData, loading: loadingPolicy } = useQuery(
    PerformanceCyclesCanManagePolicyDocument
  )

  // For now Performance cycles module is only available if user can manage cycles
  const canManageCycles = Boolean(policyData?.performanceCycles._policies.cycleManage.can)

  if (loadingPolicy)
    return (
      <Box width="full" alignItems="center" height="full" justifyContent="center">
        <Spinner />
      </Box>
    )

  return (
    <CollectionsBootstrap>
      <AuthorizeUser authorizeFn={() => canManageCycles}>
        <Outlet />
      </AuthorizeUser>
    </CollectionsBootstrap>
  )
}

export default RootPage
